/* CheapBats collection pages: home-page parity — card treatment (vendor logo, Top Pick, savings pill, no quick-add)
   + category rail inside the facet column + bigger filter text. Gated by ?cbmock=3 until Mike approves
   (window.cbCollectionParity = true removes the gate). Source: theme_src/home/cb-collection-cards.js. 2026-09-08 */
(function () {
  'use strict';
  window.cbCollectionParity = true; // CB_PARITY_LIVE (toggled by cb_parity_live.py)
  if (!(window.cbCollectionParity || /[?&]cbmock=3/.test(location.search))) return;
  if (!document.querySelector('.main-products-grid')) return;
  document.documentElement.classList.add('cb-parity');
  var picks = {}; try { var s = document.querySelector('script[data-cb-picks]'); picks = s ? (JSON.parse(s.textContent) || {}) : {}; } catch (e) {}
  function dress() {
    if (window.cbDressCards) window.cbDressCards(document, picks);
  }
  function placeRail() {
    var tpl = document.getElementById('cb-rail-tpl'), ff = document.querySelector('facet-filters .facets__filters') || document.querySelector('facet-filters form');
    if (!tpl || !ff || ff.querySelector('[data-rail]')) return;
    var rail = tpl.content.firstElementChild.cloneNode(true);
    var here = location.pathname.replace(/\/$/, '');
    rail.querySelectorAll('a[data-rail-url]').forEach(function (a) { if (a.dataset.railUrl.replace(/\/$/, '') === here) a.classList.add('is-active'); });
    wireCerts(rail); fillScopedCounts(rail);
    ff.insertBefore(rail, ff.firstChild);
  }
  // Scoped Deals links (deal collection + product_type filter) render without a count; fetch the tiny home-embed view
  // of each to read data-num-results, then show the count or drop the link if the intersection is empty.
  function fillScopedCounts(rail) {
    rail.querySelectorAll('a[data-rail-url*="filter.p.product_type"]').forEach(function (a) {
      var out = a.querySelector('span'); if (!out || out.textContent.trim()) return;
      var u = a.dataset.railUrl + (a.dataset.railUrl.indexOf('?') > -1 ? '&' : '?') + 'view=home-embed';
      fetch(u, { headers: { 'X-Requested-With': 'cb-rail' } }).then(function (r) { return r.text(); }).then(function (html) {
        var m = html.match(/data-num-results="(\d+)"/); var n = m ? parseInt(m[1], 10) : 0;
        if (n > 0) out.textContent = n; else { var grp = a.closest('.cb-rail__group'); a.closest('li').remove(); if (grp && !grp.querySelector('li')) grp.remove(); }
      }).catch(function () {});
    });
  }
  // Approved For = JustBats-style multi-select OR facet. Checked = the stamp this page is (data-cert-here) plus any
  // filter.p.m.custom.certifications values in the URL. One stamp -> its canonical landing page; 2+ -> union URL on the base.
  function wireCerts(rail) {
    var links = [].slice.call(rail.querySelectorAll('a[data-cert]')); if (!links.length) return;
    var params = new URLSearchParams(location.search), inUrl = params.getAll('filter.p.m.custom.certifications');
    var checked = {}; links.forEach(function (a) { if (a.hasAttribute('data-cert-here') || inUrl.indexOf(a.dataset.cert) > -1) checked[a.dataset.cert] = 1; });
    links.forEach(function (a) { if (checked[a.dataset.cert]) a.classList.add('is-checked'); });
    var base = rail.dataset.unionBase || '/collections/all-bats';
    links.forEach(function (a) {
      a.addEventListener('click', function (evt) {
        evt.preventDefault(); evt.stopPropagation();
        var set = Object.assign({}, checked); if (set[a.dataset.cert]) delete set[a.dataset.cert]; else set[a.dataset.cert] = 1;
        var ids = Object.keys(set), mock = /[?&]cbmock=3/.test(location.search) ? 'cbmock=3' : '';
        if (ids.length === 1) { var one = links.filter(function (l) { return l.dataset.cert === ids[0]; })[0]; location.href = one.dataset.railUrl + (mock ? '?' + mock : ''); return; }
        if (!ids.length) { location.href = base + (mock ? '?' + mock : ''); return; }
        var q = ids.map(function (g) { return 'filter.p.m.custom.certifications=' + encodeURIComponent(g); }).join('&');
        location.href = base + '?filter.v.availability=1&' + q + (mock ? '&' + mock : '');
      });
    });
  }
  // JustBats-style "Read more" on collection copy: full text stays in the DOM (Google treats expandable content as normal),
  // clamped to ~3 lines with a fade + centered button until clicked.
  function clampCopy() {
    var rte = document.querySelector('.collection-banner .rte'); if (!rte || rte.dataset.cbClamp) return; rte.dataset.cbClamp = '1';
    var row = rte.querySelector('.cb-series-row'); if (row) rte.parentNode.insertBefore(row, rte); // series pills live ABOVE the clamp
    var lh = parseFloat(getComputedStyle(rte).lineHeight) || 24; if (rte.scrollHeight <= lh * 3.6) return;
    var wrap = document.createElement('div'); wrap.className = 'cb-readmore is-clamped'; rte.parentNode.insertBefore(wrap, rte); wrap.appendChild(rte);
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'cb-readmore__btn'; btn.textContent = 'Read more'; btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () { var open = wrap.classList.toggle('is-clamped'); btn.textContent = open ? 'Read more' : 'Read less'; btn.setAttribute('aria-expanded', String(!open)); });
    wrap.appendChild(btn);
  }
  // 4-up grid like the home embed (collection.json has card_size=large → 3-up). Mock-only class swap; at go-live set
  // card_size "small" on templates/collection.json instead and this becomes a no-op.
  function fourUp() {
    document.querySelectorAll('.main-products-grid .grid[data-filters-open-classes]').forEach(function (g) {
      var fix = function (s) { return (s || '').replace('sm:grid-cols-2', 'sm:grid-cols-3').replace('xl:grid-cols-3', 'xl:grid-cols-4') + (/small-cards-desktop/.test(s) ? '' : ' small-cards-desktop'); };
      g.dataset.filtersOpenClasses = fix(g.dataset.filtersOpenClasses); g.dataset.filtersClosedClasses = fix(g.dataset.filtersClosedClasses);
      if (!/xl:grid-cols-4/.test(g.className)) g.className = fix(g.className);
    });
  }
  // JustBats layout: rail starts at the top; H1 + copy + toolbar live in the results column above the grid (desktop).
  // Mock-only DOM move; at go-live do the same in the section Liquid so it's server-rendered.
  var movedWrap = null;
  function bannerRight() {
    var grid = document.querySelector('.main-products-grid'), results = grid && grid.querySelector('.main-products-grid__results');
    if (!results) return;
    if (!movedWrap) {
      var banner = document.querySelector('.cc-collection-banner'), toolbar = document.querySelector('.cc-collection-products products-toolbar');
      if (!banner || !toolbar) return;
      movedWrap = document.createElement('div'); movedWrap.className = 'cb-banner-moved';
      var crumbs = document.querySelector('nav.breadcrumbs'); var crumbSec = crumbs && crumbs.closest('.shopify-section');
      if (crumbs) { movedWrap.appendChild(crumbs); if (crumbSec) crumbSec.classList.add('cb-crumbs-emptied'); }
      movedWrap.appendChild(banner.querySelector('.collection-banner') || banner.firstElementChild);
      movedWrap.appendChild(toolbar);
      banner.remove();
    }
    // #filter-results (= the results column) is re-rendered wholesale by the theme's facet JS; the wrap lives
    // OUTSIDE it as a sibling so it survives, positioned over the results column with CSS grid.
    if (movedWrap.parentElement !== grid) grid.insertBefore(movedWrap, results);
  }
  function run() { if (window.innerWidth >= 1024) bannerRight(); placeRail(); dress(); clampCopy(); fourUp(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var res = document.getElementById('filter-results');
  if (res) new MutationObserver(run).observe(res, { childList: true, subtree: true });
  var facets = document.querySelector('facet-filters');
  if (facets) new MutationObserver(placeRail).observe(facets, { childList: true, subtree: true });
})();
